<div [formGroup]="form" fxLayout="row" fxLayoutGap="15px">
  <mtn-license-types-select [form]="form" controlName="type" [isRequired]="true"></mtn-license-types-select>

  <mtn-datepicker-field [form]="form" controlName="expirationDate"
                        [placeholder]="'licenseForm.expirationDate' | translate">
  </mtn-datepicker-field>
</div>
